import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';

import { DragSource, DropTarget } from 'react-dnd';
import { connect } from 'react-redux';

import CalendarSession from './CalendarSession';
import CalendarItemTypes from './CalendarItemTypes';

import * as CalendarState from '../../../state/reducer/calendar/calendar';
import { TYPES as PROGRAM_TYPES } from '../../../state/reducer/calendar/programTypes';

import Console from '../../../lib/debug';
/**
 * Implements the drag source contract.
 */
const CalendarDragSource = {
    beginDrag(props) {
        CalendarState.setDragging(true);
        return {
            sessionKey: props.sessionKey,
            sessionOrder: props.sessionOrder,
            dayKey: props.dayKey,
            index: props.index
        };
    },
    endDrag() {
        CalendarState.setDragging(false);
    }
};

function connectSource(connect, monitor) {
    return {
        connectDragSource: connect.dragSource(),
        connectDragPreview: connect.dragPreview(),
        isDragging: monitor.isDragging()
    };
}

const CalendarDragTarget = {
    hover(props, monitor, component) {
        const dragIndex = monitor.getItem().sessionOrder;
        const hoverIndex = props.index;

        // Don't replace items with themselves
        if (dragIndex === hoverIndex) {
            return;
        }

        // Determine rectangle on screen
        const hoverBoundingRect = findDOMNode(
            component
        ).getBoundingClientRect();

        // Get vertical middle
        const hoverMiddleY =
            (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

        // Determine mouse position
        const clientOffset = monitor.getClientOffset();

        // Get pixels to the top
        const hoverClientY = clientOffset.y - hoverBoundingRect.top;
        // Dragging downwards
        if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
            return;
        }

        // Dragging upwards
        if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
            return;
        }

        // Time to actually perform the action
        props.moveCard(dragIndex, hoverIndex);

        // Note: we're mutating the monitor item here!
        // Generally it's better to avoid mutations,
        // but it's good here for the sake of performance
        // to avoid expensive index searches.
        monitor.getItem().sessionOrder = hoverIndex;
    }
};

function connectTarget(connect) {
    return {
        connectDropTarget: connect.dropTarget()
    };
}

class CalendarDrag extends Component {
    onClick() {}
    renderDrag(session, weekIndex, dayKey) {
        if (!this.props.isDragging) {
            return null;
        }
        return (
            <CalendarSession
                session={session}
                weekIndex={weekIndex}
                dayKey={dayKey}
            />
        );
    }

    renderItem(session, weekIndex, dayIndex, dayKey) {
        return (
            <CalendarSession
                session={session}
                weekIndex={weekIndex}
                dayIndex={dayIndex}
                dayKey={dayKey}
            />
        );
    }
    render() {
        Console.render('CalendarDrag');
        const {
            isDragging,
            connectDragSource,
            session,
            dayKey,
            weekIndex,
            dayIndex
        } = this.props;

        let allowed = session.published === 1 || session.program_type === 1;
        if (
            session &&
            (allowed &&
                CalendarState.getProgramType() !== PROGRAM_TYPES.CALENDAR)
        ) {
            return (
                <div
                    style={{ height: 'auto', width: 'auto' }}
                    className="not-draggable"
                    onMouseEnter={this.mouseEnter}
                >
                    <CalendarSession
                        session={session}
                        weekIndex={weekIndex}
                        dayIndex={dayIndex}
                        dayKey={dayKey}
                    />
                </div>
            );
        } else if (session) {
            return connectDragSource(
                <div
                    style={{ opacity: isDragging ? 0.3 : 1, cursor: 'move' }}
                    className="draggable"
                    onMouseDown={this.onClick}
                    role="presentation"
                >
                    {this.renderItem(session, weekIndex, dayIndex, dayKey)}
                </div>
            );
        } else {
            return <div />;
        }
    }
}

const mapStateToProps = (state, ownProps) => {
    let session = state.calendar.sessionTree[ownProps.sessionKey];
    if (session) {
        session = session.data;
    }
    return {
        ...ownProps,
        session
    };
};

CalendarDrag = connect(mapStateToProps)(CalendarDrag);

CalendarDrag = DropTarget(
    CalendarItemTypes.CARD,
    CalendarDragTarget,
    connectTarget
)(CalendarDrag);
export default DragSource(
    CalendarItemTypes.CARD,
    CalendarDragSource,
    connectSource
)(CalendarDrag);



// WEBPACK FOOTER //
// ./src/view/calendar/components/CalendarDrag.jsx